import { getVueTemplate } from "../../_imports/utils/utils.common";
import FormsBaseField from "./_imports/forms-base-field.vue";

export default {
	name: 'forms-checkbox-field',
	template: getVueTemplate('forms-checkbox-field'),
	mixins: [
		FormsBaseField
	],
	props: {
		id: String,
		name: String,
		value: String,
		label: String
	},
	data() {
		return {
			fieldValue: '',
			userInput: false
		}
	},
	created() {
		this.fieldValue = this.value || this.field ? this.field.value : '';
	},
	watch: {
		userInput() {
			this.validateField();

			let userInput = this.userInput;

			if (userInput === false) {
				userInput = '';
			}
			
			this.updateState(state => state.userInput = userInput);
		}
	}
};